import script from "./AddProjectPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddProjectPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__